import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import { recipes } from '../data/recipes';
import { Clock, Flame, ArrowRight } from 'lucide-react';

export const Blogs = () => {
  const featured = blogPosts.slice(0, 3);
  return (
    <section id="blogs" className="py-24 bg-[#faf7f1]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-4">
          <div>
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Journal</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] tracking-tight">
              From our nutrition journal
            </h2>
          </div>
          <Link to="/blog" className="text-sm text-[#c9743a] hover:underline underline-offset-4 font-medium">
            All {blogPosts.length} articles →
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {featured.map((b) => (
            <Link
              to={`/blog/${b.slug}`}
              key={b.slug}
              className="group cursor-pointer bg-white rounded-3xl overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-[10px] tracking-widest uppercase text-[#c9743a] bg-[#fce7d5] px-3 py-1 rounded-full">
                    {b.tag}
                  </span>
                  <span className="text-xs text-[#7a8471]">{b.date}</span>
                </div>
                <h3 className="font-serif text-xl text-[#1a2b17] leading-snug group-hover:text-[#3a5a2c] transition">
                  {b.title}
                </h3>
                <p className="text-sm text-[#4a5544] mt-3 leading-relaxed line-clamp-3">{b.description}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-sm text-[#1a2b17] group-hover:text-[#c9743a] transition">
                  Read article
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Recipes = () => {
  const featured = recipes.slice(0, 4);
  return (
    <section id="recipes" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-4">
          <div>
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Kitchen</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-[#1a2b17] tracking-tight">
              Fuss-free recipes we love
            </h2>
          </div>
          <Link to="/recipes" className="text-sm text-[#c9743a] hover:underline underline-offset-4 font-medium">
            All recipes →
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((r) => (
            <Link
              to={`/recipes/${r.slug}`}
              key={r.slug}
              className="group relative rounded-3xl overflow-hidden aspect-[4/5] cursor-pointer block"
            >
              <img
                src={r.image}
                alt={r.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="font-serif text-xl leading-tight">{r.name}</h3>
                <div className="mt-3 flex items-center gap-4 text-xs opacity-90">
                  <span className="inline-flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {r.time}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <Flame className="w-3 h-3" /> {r.calories} kcal
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
